import React from 'react';
import "./index.css";
import "./mobile.css";
import { useEffect,useState } from 'react';

function DevDiary({left,top,zIndex,indexNumber,imageSource,heading,closeFunction,moveFunction,upFunction,downFunction}) {
    const conversations = [{
        date:"18th Jan 2024",
        convo:[
            {role:"Matt",message:"I wanna put shots at the dragon music on our two ton website"},
            {role:"Matt",message:"Am I allowed to do that"},
            {role:"Kanwar",message:"yes"},
            {role:"Kanwar",message:"Yes you are"},
        ]
    },
    {
        date:"14th Jan 2024",
        convo:[
            {role:"Kanwar",message:"'We don't need to build games when we have a landing page like that'"},
            {role:"Matt",message:"Fuck the games it's all in the landing page"},
            {role:"Matt",message:"Sometimes I just open my Xbox and look at the UI"},
            {role:"Matt",message:"Lovingly"},
        ]
    },
    {
        date:"3rd Jan 2024",
        convo:[
            {role:"Matt",message:"I'm gonna send you a screenshot of our game UI design tonight"},
            {role:"Matt",message:"I haven't done characters yet so those will be coming soonish"},
            {role:"Kanwar",message:"Omg I'm so excited"},
        ]
    },
    {
        date:"4th Jan 2024",
        convo:[
            {role:"Kanwar",message:"King Fat Pat"},
            {role:"Kanwar",message:"A weasel of a man"},
            {role:"Matt",message:"What on earth"},
            {role:"Kanwar",message:"A character for the game"},
            {role:"Matt",message:"What does that do for the greater good"},
            {role:"Kanwar",message:"King Fat Pat?"},
            {role:"Kanwar",message:"Just a bloke that lives in a bin"},
    
        ]
    },
    {
        date:"8th Jan 2024",
        convo:[
            {role:"Matt",message:"I'm gonna start coding the homepage of our game tonight"},
            {role:"Kanwar",message:"Fucking hell"},
    
        ]
    },
    {
        date:"28th Dec 2023",
        convo:[
            {role:"Kanwar",message:"kardma's a good name for our skill tree"},
            {role:"Matt",message:"the kardma system is cool sounding"},
            {role:"Matt",message:"I coded the kardma system"},
    
    
        ]
    },
    {
        date:"17th Feb 2024",
        convo:[
            {role:"Kanwar",message:"Man it's so sad that gamings dying"},
            {role:"Kanwar",message:"Triple A's are fucked now"},
            {role:"Matt",message:"Yeah they are tbf"},
        ]
    },
    {
        date:"14th Feb 2024",
        convo:[
            {role:"Matt",message:"I've set up the backend for TwoTon now so email sign up should be working"},
            {role:"Kanwar",message:"Ohhhhhhh boy"},
        ]
    },
    {
        date:"12th Feb 2024",
        convo:[
            {role:"Kanwar",message:"Do the popups in reverse order then"},
            {role:"Kanwar",message:"So start with the biggest"},
            {role:"Kanwar",message:"And they get smaller when you click X"},
            {role:"Kanwar",message:"So Nyan Cat, then Welcome, then Stay in Touch"},
            {role:"Matt",message:"Yeah that's a shout tbf I'll do that"},
            {role:"Matt",message:"You're a genius this looks way way better"},
        ]
    },
    {
        date:"11th Feb 2024",
        convo:[
            {role:"Kanwar",message:"I know gaming hard cos of daddy"},
            {role:"Matt",message:"Please don't say this"},
        ]
    },
    {
        date:"10th Feb 2024",
        convo:[
            {role:"Matt",message:"We now have a desktop and a mobile version"},
            {role:"Matt",message:"I'll host a test link today so we can find bugs and improvements"},
            {role:"Kanwar",message:"Ohhhhh fuck"},
            {role:"Kanwar",message:"That's so sick"},
            {role:"Kanwar",message:"I'm so excited to run amok on it"},
        ]
    },
    {
        date:"8th Feb 2024",
        convo:[
            {role:"Matt",message:"Right"},
            {role:"Matt",message:"I'm making you a promise to hold myself accountable"},
            {role:"Matt",message:"I'm gonna watch the social network tonight"},
            {role:"Matt",message:"And then I'm going to finish the mobile version of two Ton by this weekend"},
            {role:"Kanwar",message:"Hahahahaha"},
        ]
    },
    {
        date:"1st Feb 2024",
        convo:[
            {role:"Matt",message:"All I'm thinking about is coding TwoTon"},
            {role:"Kanwar",message:"Good"},
        ]
    },
    {
        date:"31st Jan 2024",
        convo:[
            {role:"Kanwar",message:"I'm gonna be the Mark Zuckerberg to your Eduardo Saverin"},
            {role:"Matt",message:"I would accept that"},
        ]
    },
    {
        date:"22nd Feb 2024",
        convo:[
            {role:"Matt",message:"And what makes you the King?"},
            {role:"Kanwar",message:"In your eyes, what makes me the king is beating Nigel Benn. In actual fact, what confirmed that, was Michael Watson, in that fight where he battered me for 11 rounds and I nearly died that night. The man beat me almost to death and you watched it, and still you can't see. My head is bloody, may be bloody, but it is unbowed. I don't bow. I'm King."},
        ]
    },
    ];
    const [randomHighlight,SetHighlight] = useState()
    useEffect(() => {
        SetHighlight(conversations[Math.floor(Math.random() * conversations.length)]); 
      },[]);
    const renderConvoMessages = () => {
        return randomHighlight?.convo?.map((messageObj, index) => {
            const isKanwar = messageObj.role === "Kanwar";
            if(isKanwar){
                return (
                    <div key={index} className='dev-diary-message kanwar-message'>
                        <img className='kanwar-pic dev-diary-avatar' alt='Kanwar' src='../images/legacy/Kanwar.png'></img>
                        <div className='dev-diary-content'>
                        {messageObj.message}
                        </div>
                    </div>
                );
            }
            else{
                return (
                    <div key={index} className='dev-diary-message matt-message'>
                        <div className='dev-diary-content'>
                        {messageObj.message}
                        </div>
                        <img className='matt-pic dev-diary-avatar' alt='Matt' src='../images/legacy/Matt.png'></img>
                    </div>
                );
            }

        });
    };

return <div className="dialog-box" id={indexNumber} 
style={{ left: left, 
    top: top, 
    zIndex:zIndex
}}
onMouseMove={moveFunction}
onMouseUp={upFunction}
data-boxindex={indexNumber}
>
    <div className="dialog-box-heading big-text draggable-box"
     onMouseDown={downFunction}
     data-boxindex={indexNumber}
    >
        <div className="dialog-box-info draggable-box" data-boxindex={indexNumber}>
            <img className="heading-image draggable-box" src={imageSource} alt="heading" data-boxindex={indexNumber}/>
            <div className='draggable-box' data-boxindex={indexNumber}>{heading}</div>
        </div>
        <img className="close-button" src="./images/UI/close.png" alt="close button" onClick={()=>{closeFunction(indexNumber)}} />
    </div>
    <div className="dialog-box-body small-text">
    {renderConvoMessages()}
    </div>
</div>
}
export default DevDiary;
